export default "__VITE_ASSET__C6QCM08n__"